import axios from "axios";
import { getUnitApiBaseFour, SUB_URL } from "./BaseUrl";

const getUnitCode = () => {
  const unitCode = localStorage.getItem("unit_code");
  if (!unitCode) {
    throw new Error("unit_code missing");
  }
  return unitCode;
};

const DashboardService = {
  getDashboardData: async (selectArea, userData) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("user_id", userData?.su_id || "");
      formData.append("line_no", selectArea || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_dashboard_data}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      return [];
    }
  },

  getLine: async () => {
    try {
      const unitCode = getUnitCode();

      const response = await axios.get(
        `${getUnitApiBaseFour(unitCode)}${SUB_URL.getLine}`
      );

      console.log("Response Data:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching Line:", error);
      return [];
    }
  },

  getSupermarketDashboard: async () => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}/get_supermarket_dashboard`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Supermarket Dashboard Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching supermarket dashboard data:", error);
      throw error;
    }
  },

  getSupermarketActiveData: async () => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}/get_super_market_active_data`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Supermarket Active Data Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching supermarket active data:", error);
      throw error;
    }
  },

  getKanbanDataInSupermarket: async (kbNumber) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("kb_number", kbNumber || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}/get_kanban_data_in_supermarket`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Kanban Data Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching kanban data:", error);
      throw error;
    }
  },

  uploadBarcodeImage: async (kbNumber, barcodeImageFile) => {
    try {
      const unitCode = getUnitCode();

      const formData = new FormData();
      formData.append("kb_number", kbNumber || "");
      formData.append("barcode_image", barcodeImageFile || "");

      const response = await axios.post(
        `${getUnitApiBaseFour(unitCode)}/upload_barcode_image`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Barcode Upload Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error uploading barcode image:", error);
      throw error;
    }
  },
  getTodayOutwardSummary: async () => {
  const unitCode = getUnitCode();

  const response = await axios.get(
    `${getUnitApiBaseFour(unitCode)}/get_today_outward_summary`
  );

  return response.data;
},

getTodayDispatchQty: async () => {
  const unitCode = getUnitCode();

  const response = await axios.get(
    `${getUnitApiBaseFour(unitCode)}/get_today_dispatch_qty`
  );

  return response.data;
},

getTodayGsmOutwardTotal: async () => {
  const unitCode = getUnitCode();

  const response = await axios.get(
    `${getUnitApiBaseFour(unitCode)}${SUB_URL.get_today_gsm_outward_total}`
  );

  return response.data;
},
};

export default DashboardService;